import React, { useState, useRef } from "react";
import { ModalCrosSvg, ExcelSvg, ImageCroseSvg } from "../../../images/Svgs";
import { toast } from "react-toastify";
import { useDragDrop } from "../../../utils/common";
import { ImportRoutine } from "../../../API/routine";

const ImportSchedule = ({ onModalClose, EventId, fetchRoutine }) => {
  const imageInputRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [dragActive, setDragActive] = useState(false);
  const [submiting, setSubmiting] = useState(false);

  const handleImageUploadClick = () => {
    imageInputRef.current.click();
  };

  const handleFile = (file) => {
    if (file) {
      const fileType = file.type;
      if (
        fileType ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        setSelectedImage(file);
      } else {
        toast.error("Please upload a valid Excel file (.xlsx)");
      }
    }
  };

  const { handleDragOver, handleDragLeave, handleDrop } = useDragDrop(
    handleFile,
    setDragActive,
    setDragActive,
    handleFile
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedImage || submiting) return;

    try {
      setSubmiting(true);

      let formData = new FormData();
      formData.append("event_id", EventId);
      formData.append("import_file", selectedImage);

      const response = await ImportRoutine(formData);

      if (response?.status) {
        toast.success(response.message || "success !");
        fetchRoutine();
        onModalClose(false);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error during import request:", error);
      toast.error(error?.message || "Something went wrong");
    } finally {
      setSubmiting(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal fade show">
        <div className="modal-dialog">
          <div
            className="modal-content"
            style={{ position: "relative" }}
          >
            {/* 🔥 Loader Overlay */}
            {submiting && (
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: "rgba(0,0,0,0.65)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 1050,
                  borderRadius: "8px",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <div
                    className="spinner-border text-light"
                    role="status"
                  ></div>
                  <p className="mt-3 text-white">
                    Importing schedule...
                  </p>
                </div>
              </div>
            )}

            <div className="modal-header">
              <h5 className="modal-title">Import Schedule</h5>
              <button
                type="button"
                className="close"
                onClick={() => onModalClose(false)}
                disabled={submiting}
              >
                <ModalCrosSvg />
              </button>
            </div>

            <div className="modal-body">
              <div className="mt-3">
                <div
                  className={`event_file ${dragActive ? "drag-active" : ""}`}
                  onDragOver={handleDragOver}
                  onDragLeave={handleDragLeave}
                  onDrop={handleDrop}
                >
                  <div className="upload-btn-wrapper">
                    <button
                      className="vitalu_cont"
                      onClick={handleImageUploadClick}
                      disabled={submiting}
                    >
                      <div className="upload_icon">
                        <ExcelSvg />
                      </div>
                      <div className="vital_text_png">
                        <p>
                          <span>Click to upload Excel File</span> or
                          drag and drop
                        </p>
                      </div>
                    </button>

                    <input
                      type="file"
                      className="d-none"
                      accept=".xls,.xlsx"
                      ref={imageInputRef}
                      onChange={(e) =>
                        handleFile(e.target.files[0])
                      }
                    />
                  </div>

                  {selectedImage && (
                    <>
                      <h2 className="inter pb-1">
                        Uploaded Excel Files
                      </h2>
                      <div className="sample_file_icon">
                        <div className="sample_file">
                          <p className="inter">
                            {selectedImage.name}
                          </p>
                        </div>
                        <div
                          className="sample_file"
                          onClick={() => {
                            setSelectedImage(null);
                            if (imageInputRef.current) {
                              imageInputRef.current.value = "";
                            }
                          }}
                        >
                          <ImageCroseSvg />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>

              <br />

              <div className="d-flex justify-content-end gap-2 mb-3">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => onModalClose(false)}
                  disabled={submiting}
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="btn btn-dark d-flex align-items-center justify-content-center"
                  disabled={!selectedImage || submiting}
                  onClick={handleSubmit}
                >
                  {submiting && (
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                    ></span>
                  )}
                  {submiting ? "Importing..." : "Save"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImportSchedule;